const PortfolioCard = ({ data, index, isMobile }) => {
  const websiteUrl = data.developer_proj_website_url || "https://www.example.com/";

  // Handler to open the link in a new tab
  const openWebsite = (event) => {
    event.stopPropagation();
    window.open(websiteUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <a
      href={websiteUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none" }}
      className="block w-full h-full"
    >
      <div
        className="bg-white rounded-xl"
        style={{
          height: isMobile ? "250px" : "300px",
          width: "100%",
          maxWidth: "450px",
          minHeight: 0,
          minWidth: 0,
          boxShadow: "5px 10px #EBECF0",
          marginTop: "20px",
          borderWidth: "0.5px",
          borderColor: "black",
          borderStyle: "solid",
          cursor: "pointer",
          position: "relative"
        }}
      >
        <div
          className="p-3"
          style={{
            fontSize: "16px",
            display: "grid",
            gridTemplateRows: "1fr auto",
            gap: 4,
            maxWidth: "inherit",
            color: "black",
            height: "100%",
          }}
        >
          <div style={{
            width: "100%",
            height: "100%",
            overflow: "hidden",
            position: "relative"
          }}>
            <iframe
              src={websiteUrl}
              style={{
                width: "200%",
                height: "200%",
                transform: "scale(0.5)",
                transformOrigin: "0 0",
                border: "none"
              }}
              title={data.developer_proj_name}
            ></iframe>
            {/* Overlay element */}
            <div
              onClick={openWebsite}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                zIndex: 1,
                background: "transparent",
                cursor: "pointer"
              }}
              aria-label="Open project website"
              tabIndex={0}
              role="button"
              onKeyPress={event => {
                if (event.key === "Enter" || event.key === " ") openWebsite(event);
              }}
            ></div>
          </div>
          <div className="font-bold mt-2 text-center">
            {data.developer_proj_name}
          </div>
        </div>
      </div>
    </a>
  );
};

export default PortfolioCard;